<template>
  <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-position="labelPosition"
      label-width="100px"
  >
    <el-form-item
        label="机器人名称"
        prop="name"
    >
      <el-input
          placeholder="请输入"
          v-model="form.name"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="描述"
        prop="desc"
    >
      <el-input
          placeholder="请输入"
          v-model="form.desc"
      ></el-input>
    </el-form-item>
    <el-form-item
        label="token"
        prop="token"
    >
      <el-input
          type="textarea"
          placeholder="请输入"
          v-model="form.token"
          :rows="4"
          resize="none"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="状态"
      prop="pushConfig"
    >
      <el-radio
        v-model="form.status"
        :label="1"
      >启用</el-radio>
      <el-radio
          v-model="form.status"
          :label="0"
      >禁用</el-radio>
    </el-form-item>
  </el-form>
</template>

<script>
import formLabalPosition from "@/mixins/formLabalPosition";
let originForm = {
  name: '',
  desc: '',
  token: '',
  status: 1,
}
export default {
  name: "telegramForm",
  components:{
  },
  props: {
    formData:{
      type: Object,
      default(){
        return {
          ...originForm,
        }
      }
    },
  },

  data() {
    return {
      form: {
        ...originForm,
      },
      rules:{
        name: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        desc:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        token:[
          { required: true, message: '请输入', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {

  },
  mixins: [formLabalPosition],
  watch:{
    formData:{
      handler(newVal,oldVal){
        if(newVal){
            this.form = {
                ...newVal,
            }
        }
      },
      deep:true,
    },
  },
  created(){
      if(this.formData.id){
          this.form = {
              ...this.formData,
          }
      }
  },
  methods:{
    reset(){
      this.form = {
        ...originForm,
      };
    },
    validate(){
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }else {
          console.log('no-pass')
        }
      })
    },
  },
}
</script>

<style scoped>

</style>
